export const ApplicationConstant = {
    ApplicationID : 13,
    clientId : 8,
    DEFAULT_DATE_FORMAT: 'YYYY-MM-DD'
};
